import axiosClient from "./axiosClient";

export const visionApi = {
  scanCard: (userKey: number, token: string, imageBase64: string) => {
    return axiosClient.post("/scanCard", {
      userKey,
      token,
      imageBase64,
    });
  },
};
